import script from "./FileSB.vue?vue&type=script&lang=ts&setup=true"
export * from "./FileSB.vue?vue&type=script&lang=ts&setup=true"

import "./FileSB.vue?vue&type=style&index=0&id=2efb6712&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2efb6712"]])

export default __exports__